import { Window } from '../../00_IMMEDIATE/Window';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

// track how many times the FB enable messages dialog was seen
// eslint-disable-next-line no-unused-vars
G.dailyChallengeEnableAttempts = 0;

/**
 * Class for optional blocked daily challenge Opt-In prompt.
 */
class Window_DailyChallengeOptIn extends Window {
  /**
   * constructor
   * @param {Object} parent
   * @param {Object} originalIcon
   */
  constructor(parent, originalIcon) {
    super(parent);
    this._originalIcon = originalIcon;
    this._initBackgroundImages();
    this._initTitle();
    this._initOptInBtn();
    this._initContinueBtn();
    this._initBodyText();

    OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptInPopUpVisible);
  }

  /**
   * init UI images / background
   */
  _initBackgroundImages() {
    this._bg = this.addGeneric9SliceBackground(520, 610);
    this._bg.y += 30;
    this._img = G.makeImage(0, 10, 'daily_challenge_banner', 0.5, this);
  }

  /**
   * init the title text
   */
  _initTitle() {
    this._titleTxt = new G.Text(0, -240, OMT.language.getText('Daily Challenge'), {
      style: 'window-white',
      fontSize: '50px',
      lineSpacing: 0,
      fontWeight: 500,
    }, 0.5, 420);
    this.add(this._titleTxt);
  }

  /**
   * init the body text
   */
  _initBodyText() {
    this._txt = new G.Text(0, -130, OMT.language.getText('Turn on messages to access exclusive levels and challenges'), {
      style: 'window-brown',
      lineSpacing: -6,
      fontWeight: 500,
    }, 0.5, this._img.width + 30, 200, true, 'center');
    this.add(this._txt);
  }

  /**
   * init opt-in button
   */
  _initOptInBtn() {
    this._optInBtn = new OMT_UI_SquareButton(0, 175, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 216,
          height: 70,
        },
      },
      text: {
        string: OMT.language.getText('Turn On'),
        textStyle: {
          style: 'window-white',
          fontSize: '55px',
          lineSpacing: 0,
          fontWeight: 600,
        },
      },
      options: {
        clickFunction: {
          onClick: this._onOptInDC.bind(this),
        },
        pulse: 1.1,
      },
    });
    this.registerButtons(this._optInBtn);
  }

  /**
  * init the continue / no-thanks button
  */
  _initContinueBtn() {
    this._continueBtnTxt = new G.Text(0, 257, OMT.language.getText('Not Now'), {
      style: 'window-brown',
      fontSize: '25px',
      fontWeight: 600,
    }, 0.5, 420, 420, true, 'center');
    this.add(this._continueBtnTxt);
    this._continueBtnTxt.inputEnabled = true;
    this._continueBtnTxt.input.useHandCursor = true;
    this._continueBtnTxt.events.onInputDown.add(() => {
      G.saveState.data.showOptinIcon = false;
      G.saveState.setBotOptIn(false);
      G.saveState.save();
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptInPopUpNoThanks);
      this.closeWindow();
    }, this);
    this.registerButtons(this._continueBtnTxt);

    this._underline = this.game.add.graphics(this._continueBtnTxt.left, this._continueBtnTxt.bottom - 7);
    this._underline.lineStyle(4, 0xAB6420);
    this._underline.moveTo(0, 0);
    this._underline.lineTo(this._continueBtnTxt.width, 0);
    this.add(this._underline);
  }

  /**
   * on opt-in clicked
   */
  _onOptInDC() {
    G.dailyChallengeEnableAttempts++;

    let inputBlocker = new G.AdLoadOverlay();
    OMT.bots.subscribeToBot().then(() => {
      G.saveState.data.showOptinIcon = false;
      G.saveState.setBotOptIn(true);
      OMT.notifications.unscheduleAllGameTriggeredMessages('a2u');

      OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptInPopUpYes);
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptIn);
      DDNA.tracking.collectEvent('botOptionsChanged', { botSubscribtionStatus: 1, botSubscriptionChangeGameArea: 'DailyChallenge' });

      if (inputBlocker && inputBlocker.parent) {
        inputBlocker.parent.removeChild(inputBlocker);
        inputBlocker.destroy();
        inputBlocker = null;
      }
      this.closeWindow(() => {
        G.sb('pushWindow').dispatch(['dailyChallenge', G.saveState.getDailyChallengeLevel()]); // continue to daily challenge
      });
    }).catch((err) => {
      if (inputBlocker && inputBlocker.parent) {
        inputBlocker.parent.removeChild(inputBlocker);
        inputBlocker.destroy();
        inputBlocker = null;
      }
      this.closeWindow(() => {
        if (err.code === 'USER_INPUT') {
          G.saveState.data.showOptinIcon = false;
        } else {
          G.sb('pushWindow').dispatch(['howToBotOptIn', this._originalIcon]);
        }
      });
    });
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.dailyChallengeOptIn = Window_DailyChallengeOptIn;
